'use client'

import { useRouter } from 'next/navigation'
import React, { useEffect, useRef, useState } from 'react'
import { Search as SearchIcon } from 'lucide-react'

import { Input } from '@/components/ui/input'
import { useHeaderTheme } from '@/providers/HeaderTheme'

const PageClient: React.FC = () => {
  const { setHeaderTheme } = useHeaderTheme()

  useEffect(() => {
    setHeaderTheme('light')
  }, [setHeaderTheme])

  return null
}

export function SearchField({ initialQuery = '' }: { initialQuery?: string }) {
  const [value, setValue] = useState(initialQuery)
  const router = useRouter()
  const searchInputRef = useRef<HTMLInputElement>(null)

  const [prevInitialQuery, setPrevInitialQuery] = useState(initialQuery)
  if (initialQuery !== prevInitialQuery) {
    setValue(initialQuery)
    setPrevInitialQuery(initialQuery)
  }

  const applyQueryToUrl = (q: string) => {
    const trimmed = q.trim()
    const params = new URLSearchParams()
    if (trimmed) params.set('q', trimmed)
    const qs = params.toString()
    router.replace(`/search${qs ? `?${qs}` : ''}`)
  }

  return (
    <form
      className="w-full"
      onSubmit={(e) => {
        e.preventDefault()
        applyQueryToUrl(value)
      }}
    >
      <Input
        ref={searchInputRef}
        IconComponent={SearchIcon}
        placeholder="Search"
        aria-label="Search"
        autoComplete="off"
        enterKeyHint="search"
        className="w-full items-center font-body"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onClear={() => {
          setValue('')
          router.replace('/search')
        }}
      />
    </form>
  )
}

export default PageClient
